/**
 * Print Relationships chapter — Canva page-09 template plus "This month's pulse".
 * Own A4 sheet. Uses hero-relationship.jpg (user high-res pinky-swear).
 */

import React from "react";
import type { MonthlyConsultationBundle } from "../../../../utils/forecast/monthlyConsultation";
import { PdfAspectDeepDive } from "./PdfAspectDeepDive";

/**
 * Props for the PDF relationships chapter.
 */
export interface PdfChapterRelationshipsProps {
  /** Full monthly consultation payload. */
  bundle: MonthlyConsultationBundle;
  /** 1-based sequential page index among rendered sheets. */
  pageNumber?: number;
}

/**
 * Resolve Relationships scorecard row from the bundle.
 *
 * @param bundle - Monthly consultation payload
 * @returns Matching scorecard dimension or null
 */
function relationshipsScore(bundle: MonthlyConsultationBundle) {
  const rows = Array.isArray(bundle.scorecard) ? bundle.scorecard : [];
  const match = rows.find((row) => {
    const label = typeof row.label === "string" ? row.label.trim().toLowerCase() : "";
    return (
      label === "relationships" ||
      label === "relationship" ||
      label.includes("relationship") ||
      label.includes("people")
    );
  });
  return match ?? null;
}

/**
 * Relationships life-area deep dive — always starts on its own page.
 */
export const PdfChapterRelationships: React.FC<PdfChapterRelationshipsProps> = ({
  bundle,
  pageNumber,
}) => (
  <PdfAspectDeepDive
    chapterId="relationships"
    title="Relationship"
    eyebrow="Life areas"
    playbook={bundle.aspectPlaybooks.relationships}
    snapshot={bundle.aspectPalaces.relationships}
    scorecard={relationshipsScore(bundle)}
    breakBefore="always"
    pageNumber={pageNumber}
  />
);

export default PdfChapterRelationships;
